import React from 'react'
import { validateEmail } from 'shared/helpers/validate'
import 'less/app.less'

class ShareModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      screen: 'COPY',
      emails: '',
      message: '',
      showError: false,
    }
  }

  validateEmailAddresses = () => this.state.emails.split(',').every(s => validateEmail(s.trim()))

  switchToCopy = () => {
    if (this.state.screen === 'EMAIL') this.setState({ screen: 'COPY' })
  }

  switchToEmail = () => {
    if (this.state.screen === 'COPY') this.setState({ screen: 'EMAIL' })
  }

  handleEmailChange = ({ currentTarget }) => {
    this.setState({ emails: currentTarget.value })
  }

  handleMessageChange = ({ currentTarget }) => {
    this.setState({ message: currentTarget.value })
  }

  sendEmails = () => {
    const validEmails = this.validateEmailAddresses()
    if (validEmails) {
      this.props.sendEmails({
        emails: this.state.emails,
        message: this.state.message,
        ...this.props.modalState,
      })
      this.props.closeModal()
    } else {
      this.setState({ showError: true })
    }
  }

  copyUrl = () => {
    this.urlToCopy.select()
    document.execCommand('copy')
  }

  renderCopy = () => (
    <div className="copy-content">
      <h5>Copy this URL to Share</h5>
      <div className="input-group">
        <input
          type="text"
          readOnly
          ref={input => { this.urlToCopy = input }}
          className="form-control"
          value={this.props.modalState.projectOrTimeslotUrl}
        />
        <span className="input-group-btn">
          <button onClick={this.copyUrl} className="btn btn-primary" type="button">
            Copy
          </button>
        </span>
      </div>
    </div>
    )

  renderEmail = () => (
    <div className="email-content">
      <h5>Share via Email Address</h5>
      <div className={`input-group ${this.state.showError ? 'has-error' : ''}`}>
        <label className="control-label" htmlFor="emailsInput">
            Email address
          </label>
        <span className="pull-right">Seperate email addresses with a comma (,)</span>
        <input
          id="emailsInput"
          type="text"
          className="form-control"
          onChange={this.handleEmailChange}
          value={this.state.emails}
          placeholder="Email address"
        />
      </div>
      <div className="input-group">
        <label htmlFor="messageInput">Message</label>
        <textarea
          id="messageInput"
          rows="5"
          className="form-control"
          onChange={this.handleMessageChange}
          value={this.state.message}
          placeholder="Add message"
        />
      </div>
      <button type="button" onClick={this.sendEmails} className="btn btn-primary pull-right">
          Send
        </button>
    </div>
    )

  render () {
    return (
      <div className="modal-open email-modal" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-header-content">
                <h4 className="modal-title">Share via...</h4>
                <div className="modal-tabs">
                  <div
                    onClick={this.switchToCopy}
                    className={this.state.screen === 'COPY' ? 'active' : ''}
                  >
                    <i className="im-display" />
                    <span>URL</span>
                  </div>
                  {/* <div
                    onClick={this.switchToEmail}
                    className={this.state.screen === 'EMAIL' ? 'active' : ''}
                  >
                    <i className="im-envelop2" />
                    <span>Email</span>
                  </div>*/}
                </div>
                <button
                  type="button"
                  onClick={this.props.closeModal}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              {this.state.screen === 'COPY' ? this.renderCopy() : this.renderEmail()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ShareModal
